function ActionButton({
  icon,
  onClick,
  className = "",
  title = ""
}) {
  return (
    <button
      type="button"
      className={`circle-btn ${className}`}
      onClick={onClick}
      title={title}
    >
      <img
        src={icon}
        className="icon"
        alt={title}
      />
    </button>
  );
}

export default ActionButton;